import { render } from "./Carrocel.vue?vue&type=template&id=4026e430&scoped=true"
import script from "./Carrocel.vue?vue&type=script&lang=js"
export * from "./Carrocel.vue?vue&type=script&lang=js"

import "./Carrocel.vue?vue&type=style&index=0&id=4026e430&lang=scss"
import "./Carrocel.vue?vue&type=style&index=1&id=4026e430&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4026e430"]])

export default __exports__